import { render } from "./App.vue?vue&type=template&id=be3d7954"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=be3d7954&lang=css"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tm_website_oldage\\vue3_index\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__